import * as React from 'react';

export type FlagSize = 16 | 24 | 32 | 48 | 64;

interface IProps {
  code: string;
  size?: FlagSize;
  style?: React.CSSProperties;
}

export const Flag: React.SFC<IProps> = props => (
  <img
    src={`https://www.countryflags.io/${props.code}/flat/${props.size ||
      16}.png`}
    style={props.style}
  />
);

export default Flag;



// WEBPACK FOOTER //
// ./src/components/Flag/Flag.tsx